<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-tooltip v-if="display_mode == '0'">
                                <template slot="activator">
                                    <v-btn icon @mouseup.left="clearFilter()">
                                        <v-icon class="material-icons-outlined" style="font-size: 28px; margin-top: 2px"> view_column </v-icon>
                                    </v-btn>
                                </template>
                                {{ $t("lang.change_view") }}
                            </bc-tooltip>
                            <bc-btn-add v-if="hasPerm('work_orders.create')" @invoke-method="invokeMethod($event)" action="openAdd"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="refresh((force = true))"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list slot-scope="filter_menu">
                                    <v-list-tile class="pt-3 mb-3">
                                        <bc-autocomplete
                                            :focus="filter_menu"
                                            v-model="filter.device_id"
                                            :label="$t('lang.devices')"
                                            :items="devices"
                                            item-value="device_id"
                                            item-text="public_id"
                                            single-line
                                            prepend-icon="dock"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-select
                                            v-model="filter.status"
                                            :label="$t('lang.status')"
                                            :items="work_order_status_options"
                                            item-value="slug"
                                            item-text="status"
                                            single-line
                                            prepend-icon="info"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-select>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <bc-circle-loader v-if="loading"></bc-circle-loader>
                <v-card-text v-if="display_mode == 1 && loading == false" class="pa-0">
                    <v-container fluid grid-list-form :class="$bp.smallScreen ? 'px-0 py-2' : null">
                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                            <v-flex xs12 sm4 :class="$bp.smallScreen ? 'pa-0' : null">
                                <app-card customClasses="grey lighten-4 pt-4" contentCustomClass="px-0 pt-0 pb-0">
                                    <h2 class="ml-3 mb-4">{{ $t("lang.pending") }}</h2>
                                    <vue-perfect-scrollbar
                                        class="scroll-area"
                                        :style="$bp.xs ? null : 'max-height: calc(100vh - 242px); min-height: calc(100vh - 242px)'"
                                        style="overflow: hidden"
                                    >
                                        <v-card
                                            v-for="(wo, key) in filterWorkOrders('pending')"
                                            :key="key"
                                            class="ma-3 clickable"
                                            elevation="3"
                                            @click="openWorkOrderForm(wo)"
                                        >
                                            <v-layout row wrap class="pa-2">
                                                <v-flex xs8>
                                                    <h3>{{ wo.wo_number }}</h3>
                                                    <span class="body-2">{{ wo.company }}</span>
                                                    <small>{{ "Requested: " + wo.request_date }}</small>
                                                </v-flex>
                                                <!-- <v-flex xs4 style="display: flex !important">
                                                    <v-spacer></v-spacer>
                                                    <bc-tooltip>
                                                        <template slot="activator">
                                                            <v-btn icon><v-icon>call_received</v-icon></v-btn>
                                                        </template>
                                                        {{ $t("lang.receive_device") }}
                                                    </bc-tooltip>
                                                </v-flex> -->
                                                <!-- <v-flex xs12 pa-0>
                                            <div>
                                                <v-chip small :color="wo.warranty_repair_class" text-color="white">
                                                    <v-avatar :class="wo.warranty_repair == '1' ? 'success' : 'error'">
                                                        <v-icon>{{ wo.warranty_repair_icon }}</v-icon>
                                                    </v-avatar>
                                                    {{ wo.warranty_repair == "1" ? $t("lang.warranty_repair") : $t("lang.non_warranty_repair") }}
                                                </v-chip>
                                            </div>
                                        </v-flex> -->
                                            </v-layout>
                                        </v-card>
                                    </vue-perfect-scrollbar>
                                </app-card>
                            </v-flex>
                            <v-flex xs12 sm4 :class="$bp.smallScreen ? 'pa-0' : null">
                                <app-card customClasses="grey lighten-4 pt-4" contentCustomClass="px-0 pt-0 pb-0">
                                    <h2 class="ml-3 mb-4">{{ $t("lang.open") }}</h2>
                                    <vue-perfect-scrollbar
                                        class="scroll-area"
                                        :style="$bp.xs ? null : 'max-height: calc(100vh - 242px); min-height: calc(100vh - 242px)'"
                                        style="overflow: hidden"
                                    >
                                        <v-card
                                            v-for="(wo, key) in filterWorkOrders('open')"
                                            :key="key"
                                            class="ma-3 clickable"
                                            elevation="3"
                                            @click="openWorkOrderForm(wo)"
                                        >
                                            <v-layout row wrap class="pa-2">
                                                <v-flex xs8>
                                                    <h3>{{ wo.wo_number }}</h3>
                                                    <span class="body-2">{{ wo.company }}</span>
                                                    <small>{{ "Requested: " + wo.request_date }}</small>
                                                </v-flex>
                                                <v-flex xs4 style="display: flex !important">
                                                    <v-spacer></v-spacer>
                                                    <v-chip label small :color="wo.status.chip_color" text-color="white">
                                                        {{ wo.status.status }}
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </vue-perfect-scrollbar>
                                </app-card>
                            </v-flex>
                            <v-flex xs12 sm4 :class="$bp.smallScreen ? 'pa-0' : null">
                                <app-card customClasses="grey lighten-4 pt-4" contentCustomClass="px-0 pt-0 pb-3">
                                    <h2 class="ml-3 mb-4">{{ $t("lang.complete") }}</h2>
                                    <vue-perfect-scrollbar
                                        class="scroll-area"
                                        :style="$bp.xs ? null : 'max-height: calc(100vh - 242px); min-height: calc(100vh - 242px)'"
                                        style="overflow: hidden"
                                    >
                                        <v-card
                                            v-for="(wo, key) in filterWorkOrders('complete')"
                                            :key="key"
                                            class="ma-3 clickable"
                                            elevation="3"
                                            @click="openWorkOrderForm(wo)"
                                        >
                                            <v-layout row wrap class="pa-2">
                                                <v-flex xs8>
                                                    <h3>{{ wo.wo_number }}</h3>
                                                    <span class="body-2">{{ wo.company }}</span>
                                                    <small>{{ "Requested: " + wo.request_date }}</small>
                                                    <small>{{ wo.date_performed ? "Completed: " + wo.date_performed : "Completed: ---" }}</small>
                                                </v-flex>
                                                <v-flex xs4 style="display: flex !important">
                                                    <v-spacer></v-spacer>
                                                    <v-chip label small :color="wo.status.chip_color" text-color="white">
                                                        {{ wo.status.status }}
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </vue-perfect-scrollbar>
                                </app-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-text v-if="display_mode == '0' && loading == false" :class="$bp.smallScreen ? 'px-0 pt-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="hasPerm('work_orders.read') ? work_orders : []"
                        :no-data-text="$t('lang.no_data_available')"
                        hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <tr @mouseup.left="isInternalUser() ? profile(props.item.id) : displayInfo(props.item)" class="clickable">
                                <td v-if="current_user && doesNotHaveLoginType(['csr', 'producer', 'dispatcher', 'technician', 'driver', 'dispenser_mgr', 'customer', 'customer_readonly'])">
                                    {{ props.item.company }}
                                </td>
                                <td>{{ props.item.wo_number }}</td>
                                <td>{{ props.item.public_id }}</td>
                                <td>{{ props.item.request_date }}</td>
                                <td class="text-center">
                                    <v-chip label text-color="white" :color="props.item.warranty_repair_class">
                                        <span
                                            ><v-icon>{{ props.item.warranty_repair_icon }}</v-icon></span
                                        >
                                    </v-chip>
                                </td>
                                <td class="text-center">
                                    <v-chip
                                        :color="props.item.status.chip_color"
                                        style="width: 100px"
                                        class="body-2 white--text mt-0 pt-0 ml-auto justify-center"
                                        disabled
                                    >
                                        {{ $t(`lang.${props.item.status.slug}`) }}
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" path="/work_orders"></bc-pagination>
                </v-card-text>
            </v-card>
            <bc-dialog v-model="info_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.wo_info") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="info_dialog"
                            :dialog-status="info_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-divider class="my-0"></v-divider>
                    <v-card-text>
                        <v-form>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6
                                        ><b>{{ $t("lang.wo_number") }}</b
                                        >{{ current.wo_number }}</v-flex
                                    >
                                    <v-flex xs12 sm6
                                        ><b>{{ $t("lang.date_requested") }}</b
                                        >{{ current.request_date ? current.request_date : "---" }}</v-flex
                                    >
                                    <v-flex xs12 sm6
                                        ><b>{{ $t("lang.reason") }}</b
                                        >{{ current.reason_for_return ? current.reason_for_return : "---" }}</v-flex
                                    >
                                    <v-flex xs12 sm6 order-xs2 order-sm1>
                                        <b>{{ $t("lang.inbound_tracking") }}</b
                                        >{{ current.inbound_tracking_number ? current.inbound_tracking_number : "---" }}
                                    </v-flex>
                                    <v-flex class="justify-center" xs12 sm6 order-sm2 order-xs1 pl-0>
                                        <v-chip class="mr-auto" :color="current.status ? current.status.chip_color : null" small text-color="white">{{
                                            (current.status && current.status.slug ? $t(`lang.${current.status.slug}`) : "---") | capitalize
                                        }}</v-chip>
                                    </v-flex>
                                    <v-flex xs12 sm6 pt-0 pl-0 order-xs3>
                                        <v-btn
                                            @mouseup.left="current.inbound_tracking_number ? openTrackUrl(current.inbound_tracking_number) : null"
                                            style="maxwidth: 150px"
                                        >
                                            <v-icon class="pr-1" :color="current.inbound_tracking_number ? 'success' : 'error'">local_shipping</v-icon>
                                            <div>{{ $t("lang.display_shipping_info") }}</div>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6
                                        ><b>{{ $t("lang.work_completed") }}</b
                                        >{{ current.date_performed ? current.date_performed : "---" }}</v-flex
                                    >
                                    <v-flex xs12 sm6
                                        ><b>{{ $t("lang.work_performed") }}</b
                                        >{{ current.work_performed ? current.work_performed : "---" }}</v-flex
                                    >
                                    <v-flex xs12 sm6
                                        ><b>{{ $t("lang.performed_by") }}</b
                                        >{{ current.performed_by_name ? current.performed_by_name : "---" }}</v-flex
                                    >
                                    <v-flex xs12 sm6
                                        ><b>{{ $t("lang.outbound_tracking") }}</b
                                        >{{ current.outbound_tracking_number ? current.outbound_tracking_number : "---" }}
                                    </v-flex>
                                    <v-flex row xs12 sm6 pl-0 :class="$bp.xsOnly ? 'mr-auto' : 'ml-auto'">
                                        <v-btn
                                            @mouseup.left="current.outbound_tracking_number ? openTrackUrl(current.outbound_tracking_number) : null"
                                            style="maxwidth: 150px"
                                        >
                                            <v-icon class="pr-1" :color="current.outbound_tracking_number ? 'success' : 'error'">local_shipping</v-icon>
                                            <div>{{ $t("lang.display_shipping_info") }}</div>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="work_order_dialog" max-width="700">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.addWO") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="work_order_dialog"
                            :dialog-status="work_order_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form_work_order">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 pa-0 align-self-start>
                                        <v-layout row wrap>
                                            <v-flex xs12>
                                                <bc-autocomplete
                                                    :focus="work_order_dialog"
                                                    v-model="work_order.device_id"
                                                    :label="`${$t('lang.devices')} *`"
                                                    :items="devices"
                                                    item-value="device_id"
                                                    item-text="public_id"
                                                    return-object
                                                    :rules="ifValid('work_orders.device_id')"
                                                    @change="triggerWarranty"
                                                >
                                                    <template slot="append-outer">
                                                        <bc-tooltip>
                                                            <template slot="activator">
                                                                <v-icon :color="work_order.warranty_repair == '1' ? 'success' : 'error'">{{
                                                                    work_order.warranty_repair == "1" ? "check" : "close"
                                                                }}</v-icon>
                                                            </template>
                                                            {{ $t("lang.warranty_repair") }} -
                                                            {{ work_order.warranty_repair == "1" ? $t("lang.yes") : $t("lang.no") }}
                                                        </bc-tooltip>
                                                    </template>
                                                </bc-autocomplete>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-textarea
                                                    v-model="work_order.return_address"
                                                    :label="`${$t('lang.return_address')}`"
                                                    auto-grow
                                                    rows="1"
                                                    :rules="ifValid('work_orders.return_address')"
                                                ></v-textarea>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field
                                                    v-model="work_order.inbound_tracking_number"
                                                    :label="$t('lang.inbound_tracking_number')"
                                                    :counter="showCounter(work_order.inbound_tracking_number, 'work_order.inbound_tracking_number')"
                                                    :rules="ifValid('work_orders.inbound_tracking_number')"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm6 pa-0 align-self-start>
                                        <v-layout row wrap>
                                            <v-flex xs12>
                                                <v-text-field
                                                    v-model="work_order.contact_name"
                                                    :label="`${$t('lang.contact_name')}`"
                                                    :counter="showCounter(work_order.contact_name, 'work_order.contact_name')"
                                                    :rules="ifValid('work_orders.contact_name')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12>
                                                <bc-phone-input
                                                    ref="phoneInput"
                                                    :update-object="work_order"
                                                    input-name="contact_phone"
                                                    input-label="contact_phone"
                                                    :rules="ifValid('work_orders.contact_phone')"
                                                    :isRequired="false"
                                                ></bc-phone-input>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field
                                                    v-model="work_order.contact_email"
                                                    :label="`${$t('lang.contact_email')}`"
                                                    :counter="showCounter(work_order.contact_email, 'work_order.contact_email')"
                                                    :rules="ifValid('work_orders.contact_email')"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="work_order.reason_for_return"
                                            :label="`${$t('lang.reason_for_return')}`"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('work_orders.reason_for_return')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-switch
                            v-model="profile_onsave"
                            :label="profile_onsave ? $t('lang.after_save_profile') : $t('lang.after_save_stay')"
                            ripple
                            class="my-0 pa-0"
                        ></v-switch>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="work_order_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="saveWorkOrders()">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>

        <v-container fluid pa-0>
            <delete-confirmation-dialog
                ref="delete_work_orders"
                :heading="$t('lang.delete_work_order')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteWorkOrders(work_order.id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";
import app from "Main";
import _ from "lodash";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openWorkOrderForm" },
                { title: this.$t("lang.refresh"), action: "dbGetWorkOrders", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.company_id"), sortable: false },
                { text: this.$t("lang.wo_number"), sortable: false },
                { text: this.$t("lang.device_id"), sortable: false },
                { text: this.$t("lang.request_date"), sortable: false },
                {
                    text: this.$t("lang.warranty_repair"),
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("lang.status"),
                    sortable: false,
                    align: "center",
                },
            ],
            enableAddModal: true,
            enableEditModal: false,

            work_order: {},
            work_order_dialog: false,
            display_mode: null,
            filter: {
                search: "",
                page_size: 2,
                page_num: 1,
                device_id: "",
                status: "",
            },
            device_status: [
                { value: "pending", text: this.$t("lang.pending") },
                { value: "open", text: this.$t("lang.open") },
                { value: "completed", text: this.$t("lang.complete") },
                { value: "cancelled", text: this.$t("lang.cancelled") },
            ],
            info_dialog: false,
            current: {},
            profile_onsave: true,
            dbGetWorkOrders: _.debounce(this.getWorkOrders, 1500, { maxWait: 1500, leading: true, trailing: false }),
            work_order_status_options: [],
            loading: true,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.loading = true;
            _.delay(() => {
                let parsedQuery = JSON.parse(JSON.stringify(to.query));
                if (app.current_user && $.isEmptyObject(parsedQuery)) {
                    parsedQuery = { kanban: 1 };
                }
                let filtered = to.path != to.fullPath;
                store
                    .dispatch("fetchWorkOrders", {
                        body: parsedQuery,
                    })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.work_orders) {
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            if (filtered) {
                                //show list
                                vm.display_mode = "0";
                            } else {
                                //show kanban
                                vm.display_mode = "1";
                            }
                            vm.finishLoader();
                            vm.loading = false;
                        } else {
                            next({ name: "dashboard", replace: true });
                        }
                    });
            }, 500);
        });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        _.delay(() => {
            if ($.isEmptyObject(parsedQuery)) {
                parsedQuery = { kanban: 1 };
            }
            let filtered = to.path != to.fullPath;
            this.fetchWorkOrders({
                body: parsedQuery,
            }).then((data) => {
                if (typeof data !== "undefined" && data.work_orders) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    if (filtered) {
                        //show list
                        this.display_mode = "0";
                    } else {
                        //show kanban
                        this.display_mode = "1";
                    }
                    this.finishLoader();
                    this.loading = false;
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.work_orders.work_orders_filter,
            page: (state) => state.work_orders.page,
            rules_work_orders: (state) => state.work_orders.rules_work_orders,
            // work_order_status_options: (state) => state.settings.work_order_status_options,
            work_orders: (state) => state.work_orders.work_orders,
            company_options: (state) => state.companies.company_options,
            devices: (state) => state.devices.device_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchWorkOrders", "saveWorkOrder", "deleteWorkOrder", "fetchCompanies", "fetchDevices"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openWorkOrderForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_work_order) item ? this.$refs.form_work_order.resetValidation() : this.$refs.form_work_order.reset();

                    this.$nextTick(() => {
                        this.work_order = item != null ? this.assignObj2(item, this.rules_work_orders) : {};
                        this.work_order_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "work_order", params: { id: item.id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_work_order) item ? this.$refs.form_work_order.resetValidation() : this.$refs.form_work_order.reset();
                    this.work_order_dialog = true;
                } else {
                    this.$router.push({ name: "work_order" });
                }
            }
        },
        saveWorkOrders() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_work_order")) {
                    let body = this.prepForm(this.work_order, this.rules_work_orders);

                    this.saveWorkOrder({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getWorkOrders();
                                this.closeWorkOrderDialog();
                            } else {
                                if (this.profile_onsave) {
                                    this.$router.push({ name: "work_order", params: { id: data.work_order.id } });
                                } else {
                                    this.getWorkOrders();
                                    this.closeWorkOrderDialog();
                                }
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteWorkOrders(id = null) {
            this.deleteWorkOrder({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getWorkOrders();
                    this.closeWorkOrderDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeWorkOrderDialog() {
            this.work_order_dialog = false;
            this.$refs.delete_work_orders.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getWorkOrders(pg_refresh = false) {
            this.startLoader();

            this.fetchWorkOrders({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    // search company options by the company_id in the work_orders and get the company logo and set it in the work_orders
                    this.work_orders.forEach((work_order) => {
                        let company = this.company_options.find((company) => company.company_id == work_order.company_id);
                        if (company) {
                            work_order.img = company.logo ? company.logo : AppConfig.defaultProfileLogo;
                        } else {
                            work_order.img = AppConfig.defaultProfileLogo;
                        }
                    });
                })
                .finally(() => {
                    this.work_order_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        profile(id) {
            const _id = id;
            if (this.hasPerm("work_orders.update"))
                this.$router.push({
                    name: "work_order",
                    params: { id: _id },
                });
        },
        displayInfo(item) {
            this.info_dialog = true;
            this.current = item;
        },
        openAdd() {
            this.work_order_dialog = true;
        },
        triggerWarranty(device) {
            this.$nextTick(() => {
                this.work_order.device_id = device.device_id;
                this.work_order.warranty_repair = device.warranty_status;
            });
        },
        filterWorkOrders(status) {
            if (status == "pending") {
                return this.work_orders.filter((wo) => wo.status && wo.status.slug == "new_request");
            } else if (status == "open") {
                return this.work_orders.filter(
                    (wo) => wo.status && wo.status.slug != "new_request" && wo.status.slug != "complete" && wo.status.active_flag == "1"
                );
            } else if (status == "complete") {
                return this.work_orders.filter((wo) => wo.status && wo.status.slug == "complete");
            }
        },
        async refresh(force = false) {
            if (force == true) this.loading = true;
            if (this.company_options.length == 0 || force == true) await this.fetchCompanies({ body: { options: 1 } });
            if (this.work_orders.length > 0) {
                this.work_orders.forEach((work_order) => {
                    let company = this.company_options.find((company) => company.company_id == work_order.company_id);
                    if (company) {
                        work_order.img = company.logo ? company.logo : AppConfig.defaultProfileLogo;
                    } else {
                        work_order.img = AppConfig.defaultProfileLogo;
                    }
                });
            }
            if (this.devices.length == 0 || force == true) {
                let company_ids = this.current_user.accounts.map((account) => account.company_id);
                let body = { company_id: company_ids, options: 1 };
                await this.fetchDevices({
                    body: body,
                });
            }

            if (this.work_order_status_options.length == 0 || force == true) {
                await this.$store
                    .dispatch("fetchStatus", {
                        url: "status",
                        body: { module: "work_orders" },
                    })
                    .then((data) => {
                        this.work_order_status_options = data.status;
                    });
            }
            if (force == true) this.loading = false;
        },
    },
    mounted() {
        this.refresh();
    },
};
</script>
